import React from "react";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
import theme from "../theme/themeColor";
import { ThemeProvider } from "@mui/material/styles";

const CacheRefreshButton = ({ role, onClick, loading }) => {
  const isOnet = role === "onet";
  const isCompass = role === "compass";
  return (
    <ThemeProvider theme={theme}>
    <Button
      onClick={onClick}
      variant="contained"
      color="primary"
      disabled={loading}
      style={{
        backgroundColor: isOnet ? "#06305C" : isCompass ? "#C4AC66" : undefined,
            color: isOnet ? "white" : isCompass ? "white" : undefined,
      }}
      sx={{ textTransform: "none", fontWeight: "bold",  borderRadius: 2 }}

    >
      <RefreshIcon sx={{ mr: 1 }} />
      Actualiser les données
    </Button>
    </ThemeProvider>
  );
};

export default CacheRefreshButton;
